import React from "react";
import {LoadWebsiteDetailsEpic } from '../../actions/website.actions';
import {connect} from 'react-redux'
import ResourceList from '../../components/ResourceList';
import {Redirect} from 'react-router-dom';
import { withRouter } from 'react-router-dom'
import {push} from 'react-router-redux';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';


export class Menus extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      website: {menus:[]}
    };
  }

  componentDidMount() {
    this.props.loadWebsiteDetails(this.props.companyId);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps});
  }

  menuAction = (rowData) => {
    console.log('navigate to menu');
    this.props.navigateToMenu(this.state.website._id, rowData.id);
  }

  getColumns = () => {
    return [
      {name: 'menu_name', label: 'Menu Name'},
      {name: 'details', width: 68, label: 'Action', render: (rowData) => <span><FlatButton onClick={this.menuAction.bind(this,rowData)} label='Edit' primary={true}/></span>}
    ]
  }

  render() {
    if (this.props.loading) {
      return  (
      <div style={{textAlign: 'center'}}>
        <CircularProgress/>
      </div>
      );
    }


    return (
      <div>
        { this.state.website.menus 
          ? <div>
              <div style={{display: 'flex', flexDirection:'row', alignContent:'center', alignItems:'center'}}>
                <div><h1>Menus</h1></div>
                <div style={{flex:1}}>&nbsp;</div>
                <div>
                  <RaisedButton label={"+ New Menu"} primary={true} onClick={()=>this.setState({redirectToAdd: true})}/>
                      {this.state.redirectToAdd? <Redirect to="menus/add"/> : null }
                </div>
              </div>
              <ResourceList columns={this.getColumns()} data={this.state.website.menus} showCheckboxes={false}/>
            </div>
          : <div></div>
        }
      </div>
    );
  }
}

let mapStateToProps = ({websiteEndpoint, authEndpoint, nav},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false,
  website: websiteEndpoint.website,
  companyId: nav.selectedCompany? nav.selectedCompany : authEndpoint.companyId 
})

let mapDispatchToProps = (dispatch) => ({
  loadWebsiteDetails : (companyId) => dispatch(LoadWebsiteDetailsEpic(companyId)),
  navigateToMenu: (websiteId, menuId) => dispatch(push(`/websites/${websiteId}/menu/${menuId}`))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Menus));





// WEBPACK FOOTER //
// ./src/containers/Menu/Menus.js